import React, { Component } from 'react';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { SRLWrapper } from "simple-react-lightbox";
import Utils from 'utils/Utils';
import './AdventureGallery.scss';

function AdventureGallery({ Adventure }) {

    const size = Utils.getWindowBreakpoint();

    const carouselSettings = {
        className: "center",
        dots: false,
        infinite: false,
        centerPadding: "60px",
        slidesToShow: 5,
        slidesToScroll: 1,
        speed: 500,
        swipeToSlide: true,
    };

    const options = {
        settings: {
            disableKeyboardControls: true,
        },
        buttons: {
            showFullscreenButton: false,
            showThumbnailsButton: false,
            showAutoplayButton: false,
            showDownloadButton: false,
            showNextButton: false,
            showPrevButton: false,
        },
        thumbnails: {
            showThumbnails: false,
        }
    };

  return (
    <div className="adventure-header">
        <div className="content-info">
            <div className="gallery-container">
                <div className="image-selected">
                    {Adventure.images.length > 0 &&
                        <SRLWrapper options={options}>
                            <img id="img-selected" class="adventure-picture" src={Adventure.images[0][`url_${size}`]} alt="" />
                        </SRLWrapper>
                    }
                </div>
                <Slider {...carouselSettings}>
                    {Adventure.images.map((image, index) => {
                        return (
                            <img className="adventure-picture" onClick={
                                () => {
                                    document.getElementById('img-selected').src = image[`url_${size}`]; 
                                }
                            } src={`${image.url_sm}`} alt="" />
                        );
                    })}
                </Slider>
            </div>
        </div>
    </div>
  );
}

export default AdventureGallery;